angular.module('wbDashboard').controller('ReceiptControllerAurea', ['$scope', '$window', '$filter', 'User', 'Track', 'PlanningService', function ($scope, $window, $filter, User, Track, PlanningService) {

    $scope.pageData = {
        sending: false,
        errorMsg: null,
        receiptColor: "color-" + (Math.floor(Math.random()*6) + 1)
    };

    $scope.recommendation = {};
    $scope.receipt = $scope.$stateParams.receipt;
    // For testing cases randomly:
    // $scope.receipt.milestone_name = "My Milestone";
    // $scope.receipt.action = ['UPDATE_AUTO','CREATE_MILESTONE','DELETE_MILESTONE','UPDATE_MILESTONE','DEPOSIT','WITHDRAW','TRANSFER','WH_ON','WH_OFF','ADD_ACCOUNT'][Math.floor(Math.random() * 10)];
    // $scope.receipt.type = ['build_wealth', 'rainy_day', 'custom', 'retirement'][Math.floor(Math.random() * 4)];
    // $scope.receipt.amount = 10;
    if (!$scope.receipt.action) {
        $window.history.back();
        return;
    }


    if ($scope.wbBeta) {

        PlanningService.retrieveRecommendations(true);
        $scope.$watch(function () {
            return PlanningService.getRecommendations();
        }, function (recommendations) {
            if (recommendations) {
                $scope.recommendationsCount = recommendations.length;
            }
        }, true);


        var receiptData = angular.copy($scope.receipt);
        User.getReceipt(receiptData).then(function (recommendation) {
            $scope.recommendation = recommendation;

        }).catch(function () {
            $scope.recommendation = {
                header: "Share the wealth",
                message: "",
                action_text: "Invite Friends",
                action: "INVITE",
                type: "link",
                icon: "invite_present",
                recommendation_id: "Error"
            };
        }).finally(function () {
            Track.send("Receipt Viewed", "receipt", {
                trigger: $scope.receipt.action,
                recommendation: $scope.recommendation.recommendation_id + " - " + $scope.recommendation.header
            });
        });
    }

    $scope.recommendationClose = function() {
        var params = {};
        if ($scope.receipt.params) {
            params = $scope.receipt.params;
        }
        if ($scope.receipt.msId) {
            params.msId = $scope.receipt.msId;
        }
        $scope.$state.go($scope.receipt.closeTarget, params);
    };

    $scope.recommendationClicked = function() {
        Track.send("Recommendation Clicked", "receipt", {
            trigger: $scope.receipt.action,
            recommendation: $scope.recommendation.recommendation_id + " - " + $scope.recommendation.header
        });
    };

    $scope.recommendationAction = function() {
        $scope.recommendationClicked();
        switch ($scope.recommendation.action) {
            case 'CREATE_MILESTONE':
                $scope.$state.go("base.milestone-mod.create.steps", {type:$scope.recommendation.action_type});
                break;

            case 'UPDATE_AUTO':
                $scope.$state.go("base.funding.auto-deposit", {msId:$scope.receipt.msId});
                break;

            case 'ADD_ACCOUNT':
                $scope.$state.go("base.plans.detail.plan.feature.detail",{pslug:'taxplan', fslug:'taxpreferredaccount'});
                break;

            case 'INVITE':
                $scope.$state.go("base.invite");
                break;

            case 'PLANNING':
                $scope.$state.go("base.planning");
                break;

            default:
                $scope.recommendationClose();
                break;

        }
    };
    $scope.recommendationImage = function() {
        var name;

        if (!$scope.recommendation.icon) {
            return;
        }

        if ($scope.recommendation.icon.indexOf("milestone_") === 0) {
            name = $scope.recommendation.icon.slice(10);
            return "/assets/dashboard/images/aurea/milestones/" + name + ".svg";
        } else if ($scope.recommendation.icon.indexOf("info_") === 0) {
            name = $scope.recommendation.icon.slice(5);
            return "/assets/dashboard/images/aurea/illustrations/" + name + ".svg";
        } else if ($scope.recommendation.icon === "invite_present") {
            return "/assets/dashboard/images/aurea/illustrations/email_present.svg";
        } else if ($scope.recommendation.icon === "account_screwdriver") {
            return "/assets/dashboard/images/aurea/illustrations/account_screwdriver.svg";
        } else if ($scope.recommendation.icon === "funding_auto_deposit") {
            return "/assets/dashboard/images/aurea/illustrations/auto_deposit.svg";
        } else if ($scope.recommendation.icon === "services_wiseharvesting") {
            return "/assets/dashboard/images/aurea/services/wiseHarvesting.svg";
        } else if ($scope.recommendation.icon === "planning") {
            return "/assets/dashboard/images/aurea/planning/icons/icons_working_in_background.svg";
        }


    };

    switch ($scope.receipt.action) {
        case "UPDATE_AUTO":
            $scope.receipt.planning = true;
            if ($scope.receipt.auto_amount === 0) {
                $scope.receipt.header = "Auto-Deposit Paused";
                $scope.receipt.message = "Your " + $scope.receipt.milestone_name + " auto-deposit plan has been paused.";
            } else {
                $scope.receipt.header = "Auto-Deposit Updated";
                $scope.receipt.message = "Your " + $scope.receipt.milestone_name + " auto-deposit plan has been updated to " +
                                          $filter('wbCurrency')($scope.receipt.auto_amount) + " " + $scope.receipt.frequency + ".";
            }
            if ($scope.receipt.type === "wallet") {
                $scope.receipt.image = "/assets/dashboard/images/aurea/milestones/wallet+lab.svg";
            } else {
                $scope.receipt.image = "/assets/dashboard/images/aurea/milestones/" + $scope.receipt.type + ".svg";
            }
            $scope.receipt.closeTarget = "base.funding.auto-deposit";
            break;

        case "CREATE_MILESTONE":
            $scope.receipt.header = $scope.receipt.milestone_name + " Created";
            $scope.receipt.message = "Your " + $filter('wbCurrency')($scope.receipt.amount) + " deposit should be completed in 2-3 business days.";
            $scope.receipt.image = "/assets/dashboard/images/aurea/milestones/" + $scope.receipt.type + ".svg";
            $scope.receipt.closeTarget = "base.overview";
            switch ($scope.receipt.redirectSection) {
                case 'taxPreferredAccount':
                    $scope.receipt.closeTarget = "base.plans.detail.plan.feature.detail";
                    $scope.receipt.params = {pslug:'taxplan', fslug:'taxpreferredaccount'};
                    break;
                case 'rollovers':
                    $scope.receipt.closeTarget = "base.funding.rollovers.pending";
                    break;
            }
            break;

        case "UPDATE_MILESTONE":
            $scope.receipt.header = $scope.receipt.milestone_name + " Updated";
            $scope.receipt.message = "You should see your changes updated within 1 business day.";
            $scope.receipt.image = "/assets/dashboard/images/aurea/milestones/" + $scope.receipt.type + ".svg";
            $scope.receipt.closeTarget = "base.milestone.overview";
            break;

        case "DELETE_MILESTONE":
            $scope.receipt.header = $scope.receipt.milestone_name + " Deleted";
            $scope.receipt.message = "The remaining " + $filter('wbCurrency')($scope.receipt.amount) + " should transfer to your " +
                                       $scope.receipt.milestone_to_name + " milestone in 1 business day.";
            $scope.receipt.image = "/assets/dashboard/images/aurea/milestones/" + $scope.receipt.type + ".svg";
            $scope.receipt.closeTarget = "base.overview";
            break;

        case "DEPOSIT":
            $scope.receipt.planning = true;
            $scope.receipt.header = $filter('wbCurrency')($scope.receipt.amount) + " Deposit Initiated";
            $scope.receipt.message = "Your funds should be in your " + $scope.receipt.milestone_name + " milestone in 2-3 business days.";
            $scope.receipt.image = "/assets/dashboard/images/aurea/illustrations/deposit.svg";
            $scope.receipt.closeTarget = "base.overview";
            break;

        case "WITHDRAW":
            $scope.receipt.planning = true;
            $scope.receipt.header = $filter('wbCurrency')($scope.receipt.amount) + " Withdrawal Initiated";
            $scope.receipt.message = "Your funds should be in your " + $scope.receipt.bank_name + " " + $scope.receipt.bank_type + " account in 5-7 business days.";
            $scope.receipt.image = "/assets/dashboard/images/aurea/illustrations/withdrawal.svg";
            $scope.receipt.closeTarget = "base.overview";
            break;

        case "TRANSFER":
            $scope.receipt.header = $filter('wbCurrency')($scope.receipt.amount) + " Transfer Initiated";
            $scope.receipt.message = "Your funds should be in your " + $scope.receipt.milestone_name + " milestone in 1 business day.";
            $scope.receipt.image = "/assets/dashboard/images/aurea/illustrations/transfer.svg";
            $scope.receipt.closeTarget = "base.overview";
            break;

        case "WH_ON":
            $scope.receipt.header = "Tax-Loss Harvesting On";
            $scope.receipt.message = "We're already on the lookout for ways to lower your tax bill!";
            $scope.receipt.image = "/assets/dashboard/images/aurea/illustrations/supercharge.svg";
            $scope.receipt.closeTarget = "base.services.wise-harvesting";
            break;

        case "WH_OFF":
            $scope.receipt.header = "Tax-Loss Harvesting Paused";
            $scope.receipt.message = "You can turn it back on at any time.";
            $scope.receipt.image = "/assets/dashboard/images/aurea/illustrations/supercharge.svg";
            $scope.receipt.closeTarget = "base.services.wise-harvesting";
            break;

        case "ADD_ACCOUNT":
            $scope.receipt.header = $scope.receipt.account_type + " Added";
            $scope.receipt.message = "Your " + $filter('wbCurrency')($scope.receipt.amount) + " deposit should be complete in 2-3 business days.";
            $scope.receipt.image = "/assets/dashboard/images/aurea/milestones/" + $scope.receipt.type + ".svg";

            $scope.receipt.closeTarget = "base.plans.detail.plan.feature.detail";
            $scope.receipt.params = {pslug:'taxplan', fslug:'taxpreferredaccount'};
            break;
    }



}]);
